

















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { User } from '@/models/User';
import { BModal } from 'bootstrap-vue';
import { mapGetters } from 'vuex';
import { helpers, required, email, sameAs, minLength, requiredIf } from 'vuelidate/lib/validators';

@Component({
    name: 'ModalUserConfig',
    components: {
        'b-modal': BModal,
    },
    computed: mapGetters({
        account: 'account/account',
    }),
})
export default class ModalUserConfig extends Vue {
    updating: boolean = false;
    error: string = '';
    account!: User;

    firstName = '';
    lastName = '';
    email = '';
    phoneNumber = '';
    newPassword = '';
    newPasswordCheck = '';

    @Prop() user!: User;

    validations() {
        return {
            firstName: {
                required,
                minLength: minLength(2),
            },
            lastName: {
                required,
                minLength: minLength(2),
            },
            email: {
                required,
                email,
                minLength: minLength(3),
            },
            phoneNumber: {},
            newPassword: {
                required: requiredIf((value: string) => {
                    return !this.user.id && helpers.req(value);
                }),
                minLength: minLength(6),
            },
            newPasswordCheck: {
                sameAsPassword: sameAs('newPassword'),
            },
        };
    }

    reset() {
        this.error = '';
        this.firstName = this.user.firstName;
        this.lastName = this.user.lastName;
        this.email = this.user.email;
        this.phoneNumber = this.user.phoneNumber;
        this.newPassword = '';
        this.newPasswordCheck = '';
        this.updating = false;
        this.$v.$reset();
    }

    async setUser() {
        this.updating = true;
        this.$v.$touch();

        if (this.$v.$invalid) {
            return;
        }
        try {
            const userData: any = {
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phoneNumber: this.phoneNumber,
            };
            if (!!this.user.id) {
                userData.id = this.user.id;
            }
            if (this.account.organisations) {
                userData.organisations = this.account.organisations;
            }
            if (this.newPassword) {
                userData.plainPassword = this.newPassword;
            }

            const r = await this.$store.dispatch(!!this.user.id ? 'users/update' : 'users/create', userData);

            if (r.response && r.response.status === 400) {
                throw new Error(`A user with that e-mail already exists.`);
            }

            this.$bvModal.hide(`modalUserSet-${this.user.id || ''}`);
        } catch (e) {
            this.error = e;
        } finally {
            this.updating = false;
        }
    }
}
